<template>
  <b-card>
    <b-modal
      v-model="showAddModal"
      title="Add Check List"
      lazy
      @hidden="resetAddForm"
    >
      <b-form @submit.prevent="submitAddCheckList">
        <b-form-group
          label="Name"
          label-for="add-name"
        >
          <b-form-input
            id="add-name"
            v-model="addForm.name"
            required
            placeholder="Enter template name"
          />
        </b-form-group>
        <b-form-group
          label="File"
          label-for="add-file"
        >
          <b-form-file
            id="add-file"
            v-model="addForm.file"
            accept=".pdf,.doc,.docx"
            placeholder="Choose file"
          />
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button
          variant="secondary"
          @click="showAddModal = false"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="addFormSubmitting"
          @click="submitAddCheckList"
        >
          <b-spinner
            v-if="addFormSubmitting"
            small
            class="mr-50"
          />
          {{ addFormSubmitting ? 'Adding...' : 'Add' }}
        </b-button>
      </template>
    </b-modal>
    <b-row>
      <b-col md="12">
        <div class="d-flex justify-content-end">
          <b-button
            variant="primary"
            @click="addCheckListHalal()"
          >
            Add Check List
          </b-button>
        </div>
      </b-col>
      <b-col
        v-for="template in checkListHalalForm"
        :key="template.slug"
        md="6"
      >
        <b-card class="mb-2 border shadow">
          <!-- VIEW MODE -->
          <div v-if="!template.isEditing">
            <h4 class="mb-1">
              {{ template.name }}
            </h4>
            <div>
              <div class="d-flex justify-content-between">
                <a
                  :href="template.file_path"
                  target="_blank"
                >
                  <feather-icon
                    icon="FileTextIcon"
                    class="cursor-pointer"
                    color="blue"
                    size="40"
                  />
                </a>
                <div>

                  <b-button
                    size="sm"
                    variant="outline-primary"
                    class="mr-1"
                    @click="template.isEditing = true"
                  >
                    <feather-icon
                      icon="EditIcon"
                      class="cursor-pointer"
                      size="14"
                    /> Edit
                  </b-button>
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    @click="deleteCheckListHalal(template)"
                  >
                    <feather-icon
                      icon="TrashIcon"
                      class="cursor-pointer"
                      size="14"
                    /> Delete
                  </b-button>
                </div>
              </div>
            </div>
          </div>

          <!-- EDIT MODE -->
          <div v-else>
            <b-form-group label="Template Name">
              <b-form-input v-model="template.name" />
            </b-form-group>

            <b-form-group label="File">
              <b-form-file
                v-model="template.file"
                accept=".pdf,.doc,.docx"
              />
            </b-form-group>

            <div class="d-flex gap-1">
              <b-button
                v-if="!template.isChangeTemplate"
                size="sm"
                variant="success"
                class="mr-1"
                @click="editCheckListHalal(template)"
              >
                Save
              </b-button>
              <b-button
                v-if="template.isChangeTemplate"
                variant="success"
                size="sm"
                class="mr-1"
              >
                <b-spinner
                  small
                  type="grow"
                />
                Loading...
              </b-button>

              <b-button
                size="sm"
                variant="secondary"
                @click="template.isEditing = false"
              >
                Cancel
              </b-button>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'
import { required } from '@validations'
import decryptData from '@/store/auth/decryptData'

export default {
  data() {
    return {
      required,
      loader: false,
      validationErrors: {},
      errors: {},
      showAddModal: false,
      addForm: {
        name: '',
        file: null,
      },
      addFormSubmitting: false,
    }
  },
  setup() {
    const checkListHalalForm = ref([])
    return {
      checkListHalalForm,
    }
  },

  async mounted() {
    if (this.$route.params.id) {
      this.getCheckListDetails()
    }
  },
  methods: {
    getCheckListDetails() {
      axios
        .get(`halal/check-lists/office/${this.$route.params.id}`)
        .then(res => {
          const template = decryptData(res.data.payload).data.data
          this.checkListHalalForm = template.map(t => ({
            ...t,
            isEditing: false,
            isChangeTemplate: false,
          }))
        })
        .catch(error => {
          this.$toasted.show(error, {
            position: 'top-center',
            duration: 3000,
          })
        })
    },
    deleteCheckListHalal(template) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then(result => {
        if (result.isConfirmed) {
          axios
            .delete(`halal/check-lists/${template.id}`)
            .then(() => {
              this.$swal('Deleted!', 'Deleted Successfully.', 'success')
              this.getCheckListDetails()
            }).catch(error => {
              const payload = decryptData(error.response.data.payload).message
              let errorMessage = ''
              const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
              errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errorMessage,
                  icon: 'BellIcon',
                  variant: 'error',
                },
              })
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    editCheckListHalal(template) {
      if (this.$route.params.id) {
        // eslint-disable-next-line no-param-reassign
        template.isChangeTemplate = true

        const formData = new FormData()
        formData.append('_method', 'PUT')
        formData.append('name', template.name)
        if (template.file) {
          formData.append('file', template.file)
        }

        axios
          .post(
            `halal/check-lists/${template.id}`,
            formData,
          )
          .then(() => {
            this.getCheckListDetails()
          })
          .catch(error => {
            this.$toasted.show(error, {
              position: 'top-center',
              duration: 3000,
            })
          })
          .finally(() => {
            // eslint-disable-next-line no-param-reassign
            template.isChangeTemplate = false
          })
      }
    },
    addCheckListHalal() {
      this.showAddModal = true
    },
    resetAddForm() {
      this.addForm = {
        name: '',
        file: null,
      }
      this.addFormSubmitting = false
    },
    async submitAddCheckList() {
      if (!this.addForm.name) {
        this.$swal.fire('Error', 'Please enter a name.', 'error')
        return
      }

      const officeId = this.$route.params.id
      if (!officeId) {
        this.$swal.fire('Error', 'Office ID is missing.', 'error')
        return
      }

      this.addFormSubmitting = true

      const formData = new FormData()
      formData.append('office_id', officeId)
      formData.append('name', this.addForm.name)
      if (this.addForm.file) {
        formData.append('file', this.addForm.file)
      }

      try {
        await axios.post('halal/check-lists', formData)
        this.$swal.fire('Done', 'Check list added successfully.', 'success')
        this.showAddModal = false
        this.resetAddForm()
        this.getCheckListDetails()
      } catch (error) {
        const payload = error.response?.data?.payload
        const message = payload ? decryptData(payload).message : 'Failed to add check list. Please try again.'
        let errorMessage = 'An unknown error occurred'
        if (typeof message === 'object') {
          const firstArrayKey = Object.keys(message).find(key => Array.isArray(message[key]))
          errorMessage = firstArrayKey ? message[firstArrayKey][0] : JSON.stringify(message)
        } else if (typeof message === 'string') {
          errorMessage = message
        }
        this.$swal.fire('Error', errorMessage, 'error')
      } finally {
        this.addFormSubmitting = false
      }
    },
  },
}
</script>
